import { DEFAULT_REST_HOURS, parseTodayRestHours } from "@heraion/shared";
import { useAccountPref } from "@heraion/ui";

import { useAccountKey } from "../auth/useAccountKey";

// The rest «Build today's session» keeps (48 or 72 h), per account on this
// browser. Read by the doors that build the draft; the draft's chips set it.
// Twin of apps/mobile/src/progress/useTodayRestHours.ts.
export const useTodayRestHours = () =>
  useAccountPref(useAccountKey("jl.todayRestHours.v1"), parseTodayRestHours, DEFAULT_REST_HOURS);
